import React from "react";
import { Link } from "react-router-dom";
import { Lightning } from "@phosphor-icons/react";

const ProductLinks = [
  { label: "Features", to: "/#features", external: false },
  { label: "Pricing", to: "/pricing", external: false },
  { label: "Changelog", to: "/blog", external: false },
];

const CompanyLinks = [
  { label: "Blog", to: "/blog", external: false },
  { label: "Help center", to: "/help", external: false },
  { label: "Contact", to: "mailto:support@clipforge.win", external: true },
  { label: "Send feedback", to: "mailto:feedback@clipforge.win?subject=ClipForge%20feedback", external: true },
];

const FooterLink = ({ link }) => {
  const className = "hover:text-white transition-colors";
  const testid = `footer-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`;
  if (link.external || link.to.startsWith("mailto:")) {
    return <a href={link.to} className={className} data-testid={testid}>{link.label}</a>;
  }
  if (link.to.includes("#")) {
    // anchor link — use plain <a> so the browser scrolls to the section
    return <a href={link.to} className={className} data-testid={testid}>{link.label}</a>;
  }
  return <Link to={link.to} className={className} data-testid={testid}>{link.label}</Link>;
};

export const Footer = () => (
  <footer className="border-t border-white/10 mt-32 py-12 px-6 text-sm text-white/50" data-testid="footer">
    <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-8">
      <div className="col-span-2">
        <div className="flex items-center gap-2 text-white">
          <div className="w-7 h-7 rounded-md bg-[#FF3B6B] flex items-center justify-center">
            <Lightning weight="fill" size={16} className="text-white" />
          </div>
          <span className="font-semibold">ClipForge<span className="text-[#FF3B6B]">AI</span></span>
        </div>
        <p className="mt-4 max-w-sm text-white/50">The AI command center for short-form creators. Forge viral content in seconds.</p>
      </div>
      <div>
        <p className="text-white mb-3">Product</p>
        <ul className="space-y-2">
          {ProductLinks.map((l) => (
            <li key={l.label}><FooterLink link={l} /></li>
          ))}
        </ul>
      </div>
      <div>
        <p className="text-white mb-3">Company</p>
        <ul className="space-y-2">
          {CompanyLinks.map((l) => (
            <li key={l.label}><FooterLink link={l} /></li>
          ))}
        </ul>
      </div>
    </div>
    <div className="max-w-7xl mx-auto mt-10 pt-6 border-t border-white/10 flex justify-between text-xs">
      <span>© 2026 ClipForge AI</span>
      <span>Made for creators</span>
    </div>
  </footer>
);
